import React from 'react'

const SortByDescendingIcon = () => {
  return (
    <svg
      width="20px"
      height="15px"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill="#6F7171"
          d="M10.031,2.197V1.618c0-0.319-0.26-0.579-0.58-0.579H1.375c-0.32,0-0.58,0.26-0.58,0.579v0.579
c0,0.32,0.259,0.58,0.58,0.58h8.077C9.771,2.777,10.031,2.518,10.031,2.197z"
        />
        <path
          fill="#6F7171"
          d="M0.795,5.269v0.579c0,0.32,0.259,0.58,0.58,0.58h6.988c0.32,0,0.58-0.26,0.58-0.58V5.269
c0-0.319-0.26-0.579-0.58-0.579H1.375C1.054,4.689,0.795,4.949,0.795,5.269z"
        />
        <path
          fill="#6F7171"
          d="M0.795,8.921V9.5c0,0.32,0.259,0.58,0.58,0.58h5.9c0.32,0,0.58-0.26,0.58-0.58V8.921
c0-0.319-0.26-0.579-0.58-0.579h-5.9C1.054,8.342,0.795,8.602,0.795,8.921z"
        />
        <path
          fill="#6F7171"
          d="M0.795,12.978v0.579c0,0.32,0.259,0.58,0.58,0.58h4.812c0.32,0,0.58-0.26,0.58-0.58v-0.579
c0-0.319-0.26-0.579-0.58-0.579H1.375C1.054,12.398,0.795,12.658,0.795,12.978z"
        />
      </g>
      <path
        fill="#6F7171"
        d="M19.332,4.439L15.65,0.758c-0.109-0.109-0.256-0.17-0.41-0.17s-0.301,0.061-0.41,0.17l-3.682,3.682
c-0.227,0.227-0.227,0.594,0,0.82l0.41,0.409c0.107,0.108,0.256,0.17,0.409,0.17s0.302-0.062,0.409-0.17l1.994-1.993v10.156
c0,0.32,0.26,0.58,0.579,0.58h0.579c0.32,0,0.58-0.26,0.58-0.58V3.676l1.993,1.993c0.108,0.108,0.257,0.17,0.41,0.17
s0.301-0.062,0.409-0.17l0.41-0.409C19.559,5.033,19.559,4.666,19.332,4.439z"
      />
    </svg>
  )
}

export default SortByDescendingIcon

